export default {
  methods: {
    setPrinter() {
      this.$store.commit("SET_PRINTING");
    },
    printEmployees({ title, employees }) {
      let employeesHtml = "";
      const companyName = title || ""; // This is KANTINA 1 in the example, passed as title

      employees.forEach((employee, i) => {
        const employeeName = employee.name || "";
        const employeeLastname = employee.lastname || "";
        // Use email for username, or card_code if available and preferred
        const employeeUsername =
          employee.email ||
          (employee.card_code ? `${employee.card_code}@sportek` : "N/A");

        employeesHtml += `
          <div style="border-top: 1px solid #aaa;${i === employees.length - 1 ? "border-bottom: 1px solid #aaa;" : ""
          } padding: 12px 0; display: flex; justify-content: space-between; align-items: flex-start;">
            <div style="width: 18%">
              <div style="font-size: 1.1em; margin-bottom: 8px;">
                <span style="margin-right: 10px;">${employeeName}</span>
              </div>
            </div>
            <div style="width: 18%">
              <div style="font-size: 1.1em; margin-bottom: 8px;">
                <span style="margin-right: 10px;">${employeeLastname}</span>
              </div>
            </div>
              <div style="margin-bottom: 5px; font-size: 0.9em;width: 60%;">
                <div style="display: flex;width: 100%;">
                  <div style="width: 35%;text-align: right;">
                    <strong style="font-weight: bold;">Korisničko ime:</strong>
                  </div>
                  <div style="width: 65%;padding-left: 4px">${employeeUsername}</div>
                </div>
              
              </div>
            <div style="font-weight: bold; font-size: 0.9em; white-space: nowrap; margin-left: 20px; text-transform: uppercase;">
              ${companyName}
            </div>
          </div>
        `;
      });
      // <div style="display: flex;width: 100%;margin-top: 16px;">
      //           <div style="width: 35%;text-align: right"><strong style="font-weight: bold;">Lozinka:</strong></div>
      //           <div style="width: 65%;padding-left: 4px">ID sa kartice za ulaz</div>
      //         </div>

      this.printDocument({
        pageTitle: this.$t("employee_data"),
        // No main title for the document body itself, to match the image
        beforeTableHtml: employeesHtml,
        hideDatetime: true, // Set to true to hide the date/time header
        hasLogo: false,
        additionalStyles: `
          body { 
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
            font-size: 10pt; /* Base font size for the print document */
            margin: 1cm; /* Adjusted margin for content */
          }
           @media print {
                @page {
                  margin: 1cm; /* Ensure print margin is consistent */
                }
                body {
                  margin: 1cm; /* Margin for printed page */
                }
              }
        `,
      });
    },
    printEmployeeCards({
      count = 1,
      orientation = "portrait",
      employees,
      mainTitle,
      subTitle,
    }) {
      let cardsHtml = "";

      const generateCardHtml = (employee, isHalfPage = false) => {
        const employeeLastName = (employee.lastname || "").toUpperCase();
        const employeeFirstName = (employee.name || "").toUpperCase();
        let employeeFullName = `${employeeLastName} ${employeeFirstName}`.trim();

        if (employee.parent_name) {
          employeeFullName = `${employeeLastName} (${employee.parent_name.toUpperCase()}) ${employeeFirstName}`.trim();
        }

        const employeeUsername = employee.email || (employee.card_code ? `${employee.card_code}@sportek` : "N/A");
        const employeePassword = employee.password || employee.id || employee.code || employee.external_code || "N/A";

        // Smaller sizes for half page (2 cards per page)
        const styles = isHalfPage ? {
          padding: "12px 16px",
          maxWidth: "340px",
          titleSize: "13px",
          companySize: "11px",
          nameSize: "12px",
          textSize: "11px",
          smallTextSize: "10px",
          marginSmall: "4px",
          marginMedium: "6px",
          marginLarge: "8px",
          imgSize: "16px",
          qrMargin: "6px 0",
        } : {
          padding: "30px",
          maxWidth: "500px",
          titleSize: "20px",
          companySize: "18px",
          nameSize: "18px",
          textSize: "16px",
          smallTextSize: "14px",
          marginSmall: "8px",
          marginMedium: "12px",
          marginLarge: "20px",
          imgSize: "24px",
          qrMargin: "16px 0",
        };

        return `
          <div class="employee-card-wrapper" style="
            width: ${isHalfPage ? "95%" : orientation === "landscape" ? "60%" : "80%"};
            max-width: ${styles.maxWidth};
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            text-align: center;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            padding: ${styles.padding};
            border: 1px solid #ddd;
            border-radius: 8px;
            background: #fff;
            box-sizing: border-box;
            box-shadow: 0 2px 4px rgba(0,0,0,0.08);
          ">
            <div style="margin-bottom: ${styles.marginSmall}; font-size: ${styles.titleSize}; font-weight: bold; color: #333;">
              ${subTitle ? subTitle : mainTitle ? mainTitle.toUpperCase() : ""}
            </div>
            <div style="${employee.company ? "display: block;" : "display: none;"};font-size: ${styles.companySize}; margin-bottom: ${styles.marginSmall}; color: #666;">
              ${employee.company}
            </div>
            <div style="font-size: ${styles.companySize}; font-weight: bold; margin-bottom: ${styles.marginSmall}; color: #444;">
              ${subTitle ? mainTitle : ""}
            </div>
            <div style="margin: ${styles.marginMedium} 0 ${styles.marginSmall} 0; font-size: ${styles.nameSize}; font-weight: 600; color: #222;">
              ${employeeFullName}
            </div>
            <div style="margin-bottom: ${styles.marginSmall}; font-size: ${styles.textSize}; color: #333;">
              <strong style="font-weight: bold;">${this.$t('username')}:</strong> 
              <span style="color: #0066cc;">${employeeUsername}</span>
            </div>
            <div style="${employee.password ? `margin-bottom: ${styles.marginSmall};` : "display: none;"} font-size: ${styles.textSize}; color: #333;">
              <strong style="font-weight: bold;">${this.$t('password')}:</strong> 
              <span style="color: #0066cc;">${employeePassword}</span>
            </div>
            <div style="${employee.id ? `margin-bottom: ${styles.marginSmall};` : "display: none;"} font-size: ${styles.textSize}; color: #333;">
              <strong style="font-weight: bold;">Ordera ID:</strong> 
              <span style="color: #0066cc;">${employee.id}</span>
            </div>
            <div style="${employee.externalCode ? `margin-bottom: ${styles.marginMedium};` : "display: none;"} font-size: ${styles.textSize}; color: #333;">
              <strong style="font-weight: bold;">${this.$t("access_card_id")}:</strong> 
              <span style="color: #0066cc;">${employee.externalCode}</span>
            </div>
            <div class="qr-code-container" style="margin: ${employee.qr ? styles.qrMargin : "10px 0 0 0"}; font-size: ${styles.smallTextSize}; color: #666;">
              ${employee.qr || ""}
            </div>
            <div style="font-size: ${styles.smallTextSize}; color: #666; margin-bottom: ${styles.marginSmall};">
              ${this.$t('download_app')}: <span style="color: #0066cc;">https://ordera.app/mobile</span>
            </div>
            <div style="display: flex; justify-content: center; align-items: center;">
              <img id="printImage" src="https://restorani.bitlab.host/img/o.png" alt="ordera.app" 
                   style="width: ${styles.imgSize}; height: ${styles.imgSize}; object-fit: contain;"/>
            </div>
          </div>
        `;
      };

      if (count === 2) {
        // Two cards per page in portrait mode
        for (let i = 0; i < employees.length; i += 2) {
          const employee1 = employees[i];
          const employee2 = employees[i + 1];
          const isLastPage = i + 2 >= employees.length;

          cardsHtml += `
            <div class="card-page two-cards" style="
              width: 100%;
              height: 100vh;
              display: flex;
              flex-direction: column;
              justify-content: center;
              align-items: center;
              gap: 20px;
              box-sizing: border-box;
              padding: 10px 0;
              ${!isLastPage ? "page-break-after: always;" : ""}
            ">
              <div class="card-slot" style="display: flex; justify-content: center; align-items: center; width: 100%;">
                ${generateCardHtml(employee1, true)}
              </div>
              <div style="width: 80%; border-top: 1px dashed #ccc;"></div>
              ${employee2 ? `
                <div class="card-slot" style="display: flex; justify-content: center; align-items: center; width: 100%;">
                  ${generateCardHtml(employee2, true)}
                </div>
              ` : ''}
            </div>
          `;
        }
      } else {
        // One card per page (default behavior)
        employees.forEach((employee, index) => {
          const isLastCard = index === employees.length - 1;

          cardsHtml += `
            <div class="card-page" style="
              width: 100%;
              height: 100vh;
              display: flex;
              justify-content: center;
              align-items: center;
              box-sizing: border-box;
              ${!isLastCard ? "page-break-after: always;" : ""}
            ">
              ${generateCardHtml(employee, false)}
            </div>
          `;
        });
      } this.printDocument({
        pageTitle: this.$t("employee_cards"),
        beforeTableHtml: cardsHtml,
        hideDatetime: true,
        additionalStyles: `
          body { 
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; 
            font-size: 10pt;
            margin: 0;
            padding: 0;
          }
          /* QR code scaling for two cards per page */
          .card-page.two-cards .qr-code-container svg {
            width: 80px !important;
            height: 80px !important;
          }
          @media print {
            @page {
              margin: ${count === 2 ? "5mm" : "15mm"};
              size: ${orientation};
            }
            body {
              margin: 0;
              padding: 0;
            }
            /* Page control */
            .card-page {
              page-break-after: always !important;
              page-break-before: auto !important;
              page-break-inside: avoid !important;
              break-after: always !important;
              break-before: auto !important;
              break-inside: avoid !important;
              display: flex !important;
              justify-content: center !important;
              align-items: center !important;
              width: 100% !important;
              height: 100vh !important;
              min-height: 100vh !important;
              max-height: 100vh !important;
              box-sizing: border-box !important;
              overflow: hidden !important;
            }
            .card-page.two-cards {
              flex-direction: column !important;
              justify-content: center !important;
              gap: 15px !important;
              padding: 5px 0 !important;
            }
            .card-page.two-cards .qr-code-container svg {
              width: 70px !important;
              height: 70px !important;
            }
            .card-page.two-cards .employee-card-wrapper {
              max-width: 320px !important;
              padding: 10px 14px !important;
            }
            .card-page:last-child {
              page-break-after: auto !important;
              break-after: auto !important;
            }
            /* Card styling for print */
            .employee-card-wrapper {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              display: flex !important;
              flex-direction: column !important;
              justify-content: center !important;
              align-items: center !important;
              overflow: hidden !important;
            }
            .card-page:not(.two-cards) .employee-card-wrapper {
              max-width: 500px !important;
              width: ${orientation === "landscape" ? "60%" : "80%"} !important;
            }
            .card-page.two-cards .employee-card-wrapper {
              max-width: 400px !important;
              width: 90% !important;
            }
            /* Text and element control */
            * {
              box-sizing: border-box !important;
            }
            img {
              max-width: 100% !important;
              height: auto !important;
            }
            /* Prevent any content splitting */
            p, div, span, strong {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              orphans: 3;
              widows: 3;
            }
          }
          /* Screen preview styles */
          @media screen {
            .card-page {
              border: 1px dashed #ccc;
              margin-bottom: 20px;
              background: #fafafa;
            }
            .employee-card-wrapper {
              box-shadow: 0 4px 8px rgba(0,0,0,0.15);
            }
          }
        `,
        hasLogo: true,
      });
    },


    _generateDateTimeHtml(
      locale = "sr-RS",
      options = {
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        hour12: false,
      }
    ) {
      const dateTimeString = new Date().toLocaleString(locale, options);
      return `<div style="margin-top:16px;font-size:14px;">${this.$t("report_creation_datetime")}: ${dateTimeString}</div>`;
    },
    _generateTableHtml(
      headers,
      items,
      title = "",
      tableId = "printTable",
      tableStyle = "width: 100%; border-collapse: collapse; font-size: 12px;",
      beforeTableHtml = "",
      caption = "",
      showCaption = false
    ) {
      // Filter out headers with print: false
      const printableHeaders = headers.filter(h => h.print !== false);
      let tableHtml = "<div class='print-table'>";
      if (title) {
        tableHtml += `<div style="text-align: center; margin-bottom: 10px;margin-top: 16px"><h3 style="margin: 0;">${title}</h3></div>`;
      }
      if (beforeTableHtml) {
        tableHtml += beforeTableHtml;
      }
      tableHtml += `<table id="${tableId}" style="${tableStyle}">`;
      tableHtml += `<thead><tr>`;
      printableHeaders.forEach((header) => {
        const align = header.align || 'left';
        tableHtml += `<th style="text-align: ${align};">${header.text}</th>`;
      });
      tableHtml += `</tr></thead><tbody>`;
      items.forEach((item) => {
        tableHtml += `<tr>`;
        printableHeaders.forEach((header) => {
          let cellValue = "";
          if (header.value.includes(".")) {
            // Handle nested properties
            cellValue = header.value.split(".").reduce((obj, key) => {
              return obj && obj[key] !== undefined ? obj[key] : "";
            }, item);
          } else {
            cellValue = item[header.value];
          }
          const align = header.align || 'left';
          
          // Check if this column should display an image
          if (header.isImage && cellValue) {
            tableHtml += `<td style="text-align: ${align};"><img src="${cellValue}" style="width: 60px; height: 60px; object-fit: cover;" /></td>`;
          } else {
            // Use nullish check to preserve 0 values
            tableHtml += `<td style="text-align: ${align};">${cellValue !== null && cellValue !== undefined ? cellValue : ""}</td>`;
          }
        });
        tableHtml += `</tr>`;
      });
      tableHtml += `</tbody></table>`;
      if (caption || showCaption) {
        tableHtml += `<div style="margin-top:8px;font-size:12px;color:#666;text-align:center;">${caption || this._generateDateTimeHtml()}</div>`;
      }
      tableHtml += '</div>';
      return tableHtml;
    },

    _generateInvoiceCompanyHtml(company1, company2) {
      const generateCompanyHtml = (company) => {
        return `<div>
        <h2 style="margin-bottom: 0px">${company.printTitle}</h2>
        <div style="margin-top:16px;font-size:14px;">
          <strong>${this.$t("company_name")}: </strong>
          ${company.name}<br>
          <strong>${this.$t("address")}: </strong>${company.address}<br>
          <strong>${this.$t("phone")}: </strong>${company.phone}<br>
          <strong>${this.$t("email")}: </strong>${company.email}
        </div>
        </div>`;
      };

      let invoiceTemplate = `<div style="display: flex; justify-content: space-between;">`;
      invoiceTemplate += generateCompanyHtml(company1);
      if (company2) {
        invoiceTemplate += generateCompanyHtml(company2);
      }
      invoiceTemplate += `</div>`;
      return invoiceTemplate;
    },

    printMealCard(food) {
      const imageUrl = food.image_id
        ? `${this.conf.apiUrlBase}/gallery/${this.$store.state.restaurant.id}/medium/${food.image?.name || food.image_id}`
        : "https://via.placeholder.com/260x170?text=No+Image";
      const price = food.price ? Number(food.price).toFixed(2) : "";
      const groceries = (food.groceries || [])
        .map(
          (g) =>
            `<tr>
          <td style="padding:4px 12px;">${g.name || ""}</td>
          <td style="padding:4px 12px;text-align:right;">${g.pivot?.quantity || ""}</td>
          <td style="padding:4px 12px;">${g.measure || ""}</td>
        </tr>`
        )
        .join("");
      const sideDishes = (food.prilog || []).length
        ? (food.prilog || [])
          .map(
            (p) => `<li style="margin-bottom:2px;">&#10003; ${p.name}</li>`
          )
          .join("")
        : `<li style="color:#444;">Nema unesenih priloga</li>`;
      const menuTypes = (food.menu_types || [])
        .map((mt) => this.$t(mt.group))
        .join(", ");
      const qrValue = JSON.stringify({
        id: food.id,
        secure: food.qr_secret || "",
      });
      const qrImg = `<img src="https://api.qrserver.com/v1/create-qr-code/?size=120x120&data=${encodeURIComponent(
        qrValue
      )}" width="120" height="120" />`;

      const cardHtml = `
      <div class="meal-card-container" style="
        width:100%;
        min-height:100vh;
        display:flex;
        justify-content:center;
        align-items:flex-start;
        padding:20px;
        box-sizing:border-box;
        page-break-inside:avoid;
        break-inside:avoid;
      ">
        <div class="meal-card" style="
          width:480px;
          max-width:90%;
          padding:32px 24px 24px 24px;
          font-family:'Segoe UI',Tahoma,Geneva,Verdana,sans-serif;
          background:#fff;
          border-radius:16px;
          position:relative;
          box-shadow:0 4px 6px rgba(0,0,0,0.1);
          border:1px solid #ddd;
          page-break-inside:avoid;
          break-inside:avoid;
        ">
          <div style="display:flex;align-items:flex-start;flex-direction: column">
            <div style="flex-shrink:0;width:100%;">
              <div style="width:100%;padding:18px 18px 10px 18px;background-color:#fb6d3b;color:#fff;border-radius:8px 8px 0 0;">
                <div style="font-size:1.6em;font-weight:700;line-height:1.1;">${food.name || ""}</div>
                <div style="font-size:1.1em;opacity:.95;margin-top:2px;">${this.$t(food.category?.name || "")}</div>
              </div>
              <div style="display: flex;align-items: center;flex-wrap:wrap;">
                <img src="${imageUrl}" style="width:260px;height:170px;object-fit:cover;border-radius:8px;flex-shrink:0;" />
                
                <div style="flex:1;padding-left:24px;display:flex;flex-direction:column;justify-content:flex-start;min-width:200px;">
                  <div style="font-size:1.08em;margin-bottom:6px;">
                    <b>ID</b> 
                    <span style="letter-spacing:1px;">${food.id || ""}</span>
                  </div>
                  <div style="font-size:1.08em;margin-bottom:6px;">
                    <b>Šifra</b> 
                    <span style="letter-spacing:1px;">${food.code || ""}</span>
                  </div>
                  <div style="font-size:1.08em;margin-bottom:6px;">
                    <b>Cijena</b> ${price ? price + " KM" : "KM"}
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div style="margin-top:18px;font-size:1.08em;">
            <b>Opis</b> <span style="font-weight:400;">${food.description || ""}</span>
          </div>
          <div style="margin-top:4px;font-size:1.08em;">
            <b>Napomena</b> <span style="font-weight:400;">${food.note || ""}</span>
          </div>
          <div style="margin-top:22px;font-size:1.18em;font-weight:600;">Sastav</div>
          <table style="width:100%;border-collapse:collapse;font-size:1.05em;margin-top:6px;page-break-inside:auto;">
            <thead>
              <tr style="background:#fafafa;">
                <th style="text-align:left;padding:6px 12px;font-weight:600;">Namirnica</th>
                <th style="text-align:right;padding:6px 12px;font-weight:600;">Količina</th>
                <th style="text-align:left;padding:6px 12px;font-weight:600;">Jmj</th>
              </tr>
            </thead>
            <tbody>
              ${groceries}
            </tbody>
          </table>
          <div style="display:flex;align-items:flex-start;justify-content:space-between;width: 100%;margin-top: 22px;flex-wrap:wrap;">
            <div style="flex:1;min-width:250px;">
              <div style="margin-top:22px;font-size:1.08em;"><b>Prilozi uz jelo</b></div>
              <ul style="margin:8px 0 0 0;padding:0 0 0 18px;font-size:1.08em;list-style:none;">
                ${sideDishes}
              </ul>
              <div style="margin-top:12px;font-size:1.08em;">
                <b>Свакодневна понуда:</b><br/>
                <span style="font-weight:400;">${menuTypes}</span>
              </div>
            </div>
            <div style="margin-left:16px;flex-shrink:0;align-self:flex-start;display:flex;flex-direction:column;align-items:center;">
              ${qrImg}
              <div style="font-size:1em;color:#444;text-align:center;margin-top:4px;">Skeniraj za detalje o jelu</div>
            </div>
          </div>
        </div>
      </div>
      `;

      this.printDocument({
        pageTitle: food.name,
        beforeTableHtml: cardHtml,
        hideDatetime: true,
        additionalStyles: `
          @media print {
            @page {
              margin: 10mm;
              size: A4 portrait;
            }
            body { 
              background: #f5f5f5 !important; 
              margin: 0;
              padding: 0;
            }
            .meal-card-container {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              display: flex !important;
              min-height: 100vh;
              width: 100%;
            }
            .meal-card {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
              display: block !important;
              overflow: hidden;
              max-width: 100%;
            }
            /* Make sure content doesn't overflow */
            img {
              max-width: 100% !important;
              height: auto !important;
            }
            table {
              page-break-inside: auto !important;
              width: 100% !important;
            }
            tr {
              page-break-inside: avoid !important;
              break-inside: avoid !important;
            }
            /* Ensure QR and content fit properly */
            div[style*="flex-wrap"] {
              flex-wrap: wrap !important;
            }
          }
        `,
      });
    },

    printDocument(customContent = {}) {
      const {
        tables = [],
        pageTitle = "Izveštaj",
        title = "",
        subtitle = "",
        additionalStyles = "",
        headerHtml = "",
        beforeTableHtml = "",
        beforeTitleHtml = "",
        afterTableHtml = "",
        hideDatetime = false,
        footerHtml = "",
        dateTimeLocale, // Pass to _generateDateTimeHtml if provided
        dateTimeOptions, // Pass to _generateDateTimeHtml if provided
        company1 = {}, // Pass to _generateInvoiceCompanyHtml if provided
        company2 = {}, // Pass to _generateInvoiceCompanyHtml if provided
        signature = {
          left: { name: "", title: "" },
          right: { name: "", title: "" },
        },
        printWindowFeatures = "left=0,top=0,width=3950,height=900,toolbar=0,scrollbars=0,status=0",
        hasLogo = false, // Flag to determine if logo should be included
      } = customContent;

      const generatedDateTimeHtml = this._generateDateTimeHtml(
        dateTimeLocale,
        dateTimeOptions
      );

      let documentBodyHtml = headerHtml;
      if (!hideDatetime) {
        documentBodyHtml += generatedDateTimeHtml;
      }
      if (company1.id) {
        documentBodyHtml += this._generateInvoiceCompanyHtml(
          company1,
          company2
        );
      }
      documentBodyHtml += beforeTitleHtml;
      if (title) {
        documentBodyHtml += `<div style="text-align: center;">
            <h2>${title}</h2>
          </div>`;
      }
      if (subtitle) {
        documentBodyHtml += `<div style="text-align: center;">
            <h3>${subtitle}</h3>
          </div>`;
      }
      documentBodyHtml += beforeTableHtml;
      tables.forEach((table) => {
        const { headers, items, title: tableTitle, subtitle: tableSubtitle, beforeTableHtml, caption, showCaption } = table;

        // Add table title if it exists
        if (tableTitle) {
          documentBodyHtml += `<div style="text-align: center; margin-top: 20px; margin-bottom: 10px;">
            <h3 style="margin: 0;">${tableTitle}</h3>
          </div>`;
        }

        documentBodyHtml += this._generateTableHtml(headers, items, '', '', '', beforeTableHtml, caption, showCaption);
      });
      documentBodyHtml += afterTableHtml;

      if (
        signature.left?.title ||
        signature.left?.name ||
        signature.right?.title ||
        signature.right?.name
      ) {
        documentBodyHtml += `<div style="margin-top: 40px; display: flex; justify-content: space-between; width: 100%;">`;
        if (signature.left?.title || signature.left?.name) {
          documentBodyHtml += `<div style="text-align: left;">
            <div>${signature.left.title}</div>
            <div style="margin-top: 20px;">_________________________</div>
             <div style="margin-top: 5px;">${signature.left.name}</div>
          </div>`;
        } else {
          // Add an empty div to maintain space-between behavior if only right signature is present
          documentBodyHtml += `<div></div>`;
        }

        if (signature.right) {
          documentBodyHtml += `<div style="text-align: right;">
            <div>${signature.right.title}</div>
            <div style="margin-top: 20px;">_________________________</div>
             <div style="margin-top: 5px;">${signature.right.name}</div>
          </div>`;
        }
        documentBodyHtml += `</div>`;
      }

      documentBodyHtml += footerHtml;

      const printWindow = window.open("", "", printWindowFeatures);
      printWindow.document.write(`<!DOCTYPE html>
        <html>
          <head>
            <title>${pageTitle}</title>
            <style>
              @media print {
                @page {
                  margin: 1.5cm 0;
                  size: auto; /* auto is the initial value */
                }
                body {
                  margin: 0 1.5cm; /* Margin for printed page */
                }
              }
              body { font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif; color: #333; }
              table {
                border-collapse: collapse;
                width: 100%;
                margin-top: 8px;
                box-shadow: 0 2px 3px rgba(0,0,0,0.1);
              }
              th, td {
                border: 1px solid #e0e0e0; /* Lighter border */
                text-align: left;
                padding: 10px 12px; /* Increased padding */
              }
              th {
                background-color: #f8f9fa; /* Light gray background for headers */
                color: #212529; /* Darker text for headers */
                font-weight: 600; /* Bolder header text */
              }
              tr:nth-child(even) {
                background-color: #fdfdfd; /* Very light alternating row color */
              }
              tr:hover {
                background-color: #f1f1f1; /* Hover effect for rows */
              }
              ${additionalStyles} /* Inject user-defined styles */
            </style>
          </head>
          <body onafterprint="window.close()">
            ${documentBodyHtml}
          </body>
        </html>`);
      printWindow.document.close();
      // Wait for both the window and image to load
      if (hasLogo) {
        const interval = setInterval(() => {
          const img = printWindow.document.getElementById("printImage");

          if (img && img.complete) {
            clearInterval(interval);
            setTimeout(() => {
              printWindow.focus();
              printWindow.print();
            }, 100); // slight delay ensures rendering is complete
          }
        }, 100);
      } else {
        printWindow.focus();
        printWindow.print();
      }
    },
  },
  computed: {
    isPrinting() {
      return this.$store.state.isPrinting;
    },
  },
};
